export default "__VITE_ASSET__BPcQRyns__"